import React, {
    Component,
    useState
} from 'react'
import {
    Nav,
    NavLink,
    Link,
} from 'react-router-dom'
import { actionTypes } from '~/constants';
import Icon from '@material-ui/core/Icon';

import fetch from '~/utils/fetch';

import LinkButton from '~/widgets/button-link'
import XInput from '~/widgets/x-input';
import XDate from '~/widgets/x-date';
import XSwitch from '~/widgets/x-switch';

import { EntityType as EntityTypeEnums } from '@exmarx/shared/enums/EntityType';
import { State as StateEnums } from '@exmarx/shared/enums/State';

const ENTITY_TYPES = [];
for(const EntityType in EntityTypeEnums){
    ENTITY_TYPES.push({
        label: EntityType,
        value: EntityType
    });
}

const STATE_NAMES = [];
for(const State in StateEnums){
    STATE_NAMES.push({
        label: State,
        value: State
    });
}

class Container extends Component {
    constructor() {
        super()
        this.state = {
            error: null,
            is_loaded: false,
            is_editing: false,
            department: {
                active: true,
                address: {},
                contact: {},
                createdAt: new Date(),
                updatedAt: new Date()
            },
        }
    }

    async componentDidMount() {
        this.props.dispatch({type: actionTypes.DEPARTMENTS_CLEAR_DETAIL})
        if(this.props.match.params.department_id){
            this.props.dispatch({type: actionTypes.DEPARTMENTS_FETCH_ONE, id: this.props.match.params.department_id})
        }else{
            this.setState({
                is_loaded: true
            })
        }
    }

    bindState(path, value, third) {
        const newState = Object.assign({}, this.state);
        _.set(newState, path, value);
        this.setState(newState);
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.departments.is_loaded && prevProps.departments.is_loaded !== this.props.departments.is_loaded){
            this.setState({
                is_loaded: true,
                department: {
                    ...this.state.department,
                    ...this.props.departments.detail
                }
            })
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        if(this.props.departments.detail !== null){
            // editing
            this.props.dispatch({
                type: actionTypes.DEPARTMENTS_UPDATE_ONE,
                id: this.props.departments.detail._id,
                data: {
                    ...this.props.departments.detail,
                    ...this.state.department
                }
            });
        }else{
            // creating
            this.props.dispatch({
                type: actionTypes.DEPARTMENTS_CREATE_ONE,
                data: {
                    ...this.state.department
                }
            });
        }
    }

    render() {
        console.log(this.state);

        if(!this.state.is_loaded){
            return 'Loading...'  // hide while loading
        }

        return (
            <form onSubmit={this.handleSubmit.bind(this)}> {/* parent is div.page */}
                <div className="page-nav">
                    <div className="breadcrumb">
                        <LinkButton to={`/app/departments/${this.props.match.params.department_id || ''}`} className="button button-clear">
                            <Icon>arrow_back</Icon>&nbsp;&nbsp;Return
                        </LinkButton>
                    </div>
                    <div className="page-actions">
                        <LinkButton className="button button-secondary button-wide" type="submit">
                            <Icon>save</Icon>&nbsp;&nbsp;Save Client
                        </LinkButton>
                    </div>
                </div>
                <div className="card">
                    {this.props.departments.detail ? (
                        <div className="card-heading">
                            <div className="card-heading-action">
                                Editing
                            </div>
                            <div className="card-heading-arrow">
                                <Icon>arrow_forward</Icon>
                            </div>
                            <div className="card-heading-text">
                                {this.props.departments.detail.name}
                            </div>
                        </div>
                    ) : (
                        <div className="card-heading">
                            <div className="card-heading-action">
                                Create
                            </div>
                            <div className="card-heading-arrow">
                                <Icon>arrow_forward</Icon>
                            </div>
                            <div className="card-heading-text">
                                New Client
                            </div>
                        </div>
                    )}
                    <div className="card-content">
                        <div className="form-sections">
                            <div className="form-section">
                                <div className="form-section-heading">
                                    General
                                </div>
                                <div className="form-row">
                                    <XInput
                                        label="Dept. Name"
                                        required={true}
                                        name='name'
                                        handleChange={this.bindState.bind(this, 'department.name')}
                                        value={this.state.department.name}
                                    />
                                </div>
                                <div className="form-row">
                                    <XInput
                                        label="Branch"
                                        required={false}
                                        name='branch'
                                        handleChange={this.bindState.bind(this, 'department.branch')}
                                        value={this.state.department.branch}
                                    />
                                </div>
                                <div className="form-row">
                                    <XInput
                                        label="Entity Type"
                                        required={true}
                                        name='entityType'
                                        handleChange={this.bindState.bind(this, 'department.entityType')}
                                        value={this.state.department.entityType}
                                        choices={ENTITY_TYPES}
                                    />
                                </div>
                                <div className="form-row">
                                    <XInput
                                        label="Phone"
                                        required={true}
                                        name='phone'
                                        handleChange={this.bindState.bind(this, 'department.phone')}
                                        value={this.state.department.phone}
                                    />
                                </div>
                                <div className="form-row">
                                    <XInput
                                        label="Fax"
                                        required={false}
                                        name='fax'
                                        handleChange={this.bindState.bind(this, 'department.fax')}
                                        value={this.state.department.fax}
                                    />
                                </div>
                                <div className="form-row">
                                    <XInput
                                        label="Notes"
                                        required={false}
                                        multiline={true}
                                        rows={5}
                                        name='notes'
                                        handleChange={this.bindState.bind(this, 'department.notes')}
                                        value={this.state.department.notes}
                                    />
                                </div>
                                <div className="form-row">
                                    <XDate
                                        label="Created At"
                                        value={this.state.department.createdAt}
                                    />
                                </div>
                                <div className="form-row">
                                    <XDate
                                        label="Updated At"
                                        value={this.state.department.updatedAt}
                                    />
                                </div>
                                <div className="form-row">
                                    <XSwitch
                                        label="Active"
                                        name="active"
                                        value={this.state.department.active}
                                        handleChange={this.bindState.bind(this, 'department.active')}
                                    />
                                </div>
                            </div>
                            <div className="form-section">
                                <div className="form-section-heading">
                                    Address
                                </div>
                                <div className="form-row">
                                    <XInput
                                        label="Street"
                                        required={true}
                                        name='street'
                                        handleChange={this.bindState.bind(this, 'department.address.street')}
                                        value={this.state.department.address.street}
                                    />
                                </div>
                                <div className="form-row">
                                    <XInput
                                        label="Street Ext"
                                        required={false}
                                        name='streetExt'
                                        handleChange={this.bindState.bind(this, 'department.address.streetExt')}
                                        value={this.state.department.address.streetExt}
                                    />
                                </div>
                                <div className="form-row">
                                    <XInput
                                        label="City"
                                        required={true}
                                        name='city'
                                        handleChange={this.bindState.bind(this, 'department.address.city')}
                                        value={this.state.department.address.city}
                                    />
                                    <XInput
                                        label="State"
                                        required={true}
                                        name='state'
                                        handleChange={this.bindState.bind(this, 'department.address.state')}
                                        value={this.state.department.address.state}
                                        choices={STATE_NAMES}
                                        style={{minWidth: '85px'}}
                                    />
                                    <XInput
                                        label="Postal Code"
                                        required={true}
                                        name='zip'
                                        handleChange={this.bindState.bind(this, 'department.address.zip')}
                                        value={this.state.department.address.zip}
                                    />
                                </div>
                                <div className="form-row">
                                    <XInput
                                        label="Country"
                                        required={true}
                                        name='country'
                                        handleChange={this.bindState.bind(this, 'department.address.country')}
                                        value={this.state.department.address.country}
                                    />
                                </div>
                                <br/><br/>
                                <div className="form-section-heading">
                                    Contact
                                </div>
                                <div className="form-row">
                                    <XInput
                                        label="First Name"
                                        required={true}
                                        name='firstname'
                                        handleChange={this.bindState.bind(this, 'department.contact.firstname')}
                                        value={this.state.department.contact.firstname}
                                    />
                                    <XInput
                                        label="Middle Initial"
                                        name='middleInitial'
                                        handleChange={this.bindState.bind(this, 'department.contact.middleInitial')}
                                        value={this.state.department.contact.middleInitial}
                                    />
                                    <XInput
                                        label="Last Name"
                                        required={true}
                                        name='lastname'
                                        handleChange={this.bindState.bind(this, 'department.contact.lastname')}
                                        value={this.state.department.contact.lastname}
                                    />
                                </div>
                                <div className="form-row">
                                    <XInput
                                        label="Email"
                                        required={true}
                                        name='email'
                                        handleChange={this.bindState.bind(this, 'department.contact.email')}
                                        value={this.state.department.contact.email}
                                    />
                                </div>
                                <div className="form-row">
                                    <XInput
                                        label="Phone"
                                        required={true}
                                        name='phone'
                                        handleChange={this.bindState.bind(this, 'department.contact.phone')}
                                        value={this.state.department.contact.phone}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

import { connect } from 'react-redux'
export default connect(
    (state)=>{
        return {
            departments: state.departments,
        }
    },
    (dispatch)=>{
        return {
            dispatch: dispatch
        }
    },
    null,
    {pure: false}
)(Container);